/* -------------------- */
/* ---- Text2Speech --- */
/* -------------------- */

( function () {

    /**
     * Toggle the given element from display none <-> block
     * @param elem
     */
    function toggle_elem( elem ) {
        if ( elem.style.display === 'none' ) {
            elem.style.display = 'block';
        } else {
            elem.style.display = 'none';
        }
    }

    /**
     *  Do the logic after the content is loaded.
     */
    document.addEventListener( 'DOMContentLoaded', () => {
        const text2speech_button = document.getElementById( 'text2speechButton' );
        const audio_player = document.getElementById( 'audioPlayer' );
        const audio_element = audio_player.querySelector( 'audio' );

        text2speech_button.querySelector( 'a' ).addEventListener( 'click', () => {
            const cookie_bar = document.getElementById( 'cookie-notice' );

            if ( cookie_bar && cookie_bar.length ) {
                cookie_bar.style.zIndex = '90';
            }

            text2speech_button.classList.toggle( 'active' );
            toggle_elem( audio_player );

            if ( audio_element.currentTime === 0 ) {
                // must be called via jquery, otherwise not working
                /// @TODO: find out why and remove jquery dependency (using dispatchEvent instead of jquery's trigger())
                jQuery ( audio_element ).trigger( 'play' );
            } else {
                stopAudio();
            }

            // Google Analytics Tracking
            if ( window.ga && ga.create ) {
                ga( 'send', 'event', 'Vorlesen auf ' + window.location.pathname, 'Vorlesen-Klick' );

                //AddTrack the click if the user listend at least 20 seconds
                setTimeout( function() {
                    if( audio_element.currentTime > 0 && audio_element.currentTime > 20 ) {
                        const event_text = 'min. ' + Math.round( audio_element.currentTime ) + ' Sekunden';
                        ga( 'send', 'event', 'Vorlesen auf ' + window.location.pathname, event_text );
                    }
                }, 25000 );  //Wait 50 seconds for check
            }
        } );

        /*
        *   Stop the player
        */
        function stopAudio() {
            // pause playing
            // event must be called via jquery, otherwise not working
            /// @TODO: find out why and remove jquery dependency (using dispatchEvent instead of jquery's trigger())
            jQuery ( audio_element ).trigger( 'pause' );
            audio_element.currentTime = 0;
        }

        /**
         *  Hide and stop the player when clicking close button.
         */
        audio_player.querySelector( '.closeAudioPlayer' ).addEventListener( 'click', function() {
            stopAudio();
            text2speech_button.classList.toggle( 'active' );
            toggle_elem( audio_player );
        } );
    } );

} ) ();
